// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import VueErrorHandlerPlugins from '@58fe/ems-plugins/lib/vue'
import VueFullPage from 'vue-fullpage.js'
import 'vue-fullpage.js/dist/vue-fullpage.min.js'

//fullpage
Vue.use(VueFullPage);
// 异常捕获则
Vue.use(VueErrorHandlerPlugins)

Vue.use(VueResource)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	template: '<App/>',
	components: {
		App
	}
})



// WEBPACK FOOTER //
// ./src/main.js